<template>
    <academic>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg" >
            <loading :showLoading="form.processing" />
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Add Subject</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Subject Title'"/>
                            <breeze-input required v-model="form.title" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.title:''" />
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Subject Code'"/>
                            <breeze-input required v-model="form.code" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.code:''" />
                        </div>
                        <div class="">
                            <breeze-label :value="'Private'"/>
                            <input-checkbox type="radio" class="rounded-full" name="type" value="private" required v-model="form.type" />
                            <breeze-input-error :message="form.errors?form.errors.type:''" />
                        </div>
                        <div class="">
                            <breeze-label :value="'University'"/>
                            <input-checkbox type="radio" class="rounded-full" name="type" value="university" required v-model="form.type" />
                            <breeze-input-error :message="form.errors?form.errors.type:''" />
                        </div>
                        <div class="">
                            <breeze-label :value="'Status'"/>
                            <breeze-checkbox v-model="form.status"/>
                            <breeze-input-error :message="form.errors?form.errors.status:''" />
                        </div>
                    </div>
                    <button-link :href="route('academic.subject.list')" class="bg-red-500 mr-4 hover:bg-red-400">Cancel</button-link>
                    <breeze-button :disabled="form.processing">Save</breeze-button>
                    <exception />
                </form>
            </div>
        </div>
    </academic>
</template>

<script>
    import Academic from '@/Pages/Academic/Academic'
    import BreezeTable from '@/Components/Table'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import InputCheckbox from '@/Components/InputCheckbox'
    import BreezeInputError from '@/Components/InputError'
    import ButtonLink from '@/Components/ButtonLink'
    import Exception from '@/Components/Exception'
    import Loading from '@/Components/Loading'
    import { useForm } from '@inertiajs/inertia-vue3'

    export default {
        components: {
            Academic,
            BreezeTable,
            ButtonLink,
            BreezeInput,
            BreezeCheckbox,
            BreezeLabel,
            BreezeInputError,
            BreezeButton,
            Exception,
            Loading,
            InputCheckbox
        },
        data(){
            return{
                form: useForm({
                    title: '',
                    code: '',
                    type: '',
                    status: true,
                })
            }
        },
        methods: {
            submitForm() {
                console.log(this.form)
                this.form.post(route('academic.subject.store'),{
                    preserveScroll: true,
                    onSuccess: () => this.form.reset(),
                });
            },
        },
    }
</script>
